<button class="btn-close" (click)="closeModal.emit()"></button>
<ng-content></ng-content>
